import { render, staticRenderFns } from "./UserLoanDetail.vue?vue&type=template&id=6f5a8a41"
import script from "./UserLoanDetail.vue?vue&type=script&lang=js"
export * from "./UserLoanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports